import { Icon3d3d, Icon3dAlert, Icon3dCycle, Icon3dDetect, Icon3dLocation, Icon3dMeter, IconMeter, IconWarning, IconZoneGray } from '@assets/images/icon';
import { accessAutoThumb, deadboltThumb, emlockThumb } from '@assets/images/main/access/product';
import { IconAoaOff, IconAoaOn, IconComfortOff, IconComfortOn, IconOsOff, IconOsOn, IconTwintrackerOff, IconTwintrackerOn } from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import {
  accessKey1,
  accessKey2,
  accessKey3,
  accessKey4,
  accessOutlook,
  IconBox,
  IconComputer,
  IconGuarantee,
  assetOn,
  workerOn,
  workerOff,
  IconPath,
  IconLocation,
  IconAnalyze,
  IconAlarm,
  IconExcel,
  IconSDK,
  assetOff,
  rtlsScreenshot1D,
  rtlsScreenshot1T,
  rtlsScreenshot1M,
  rtlsScreenshot2D,
  rtlsScreenshot2T,
  rtlsScreenshot2M,
  rtlsScreenshot3D,
  rtlsScreenshot3T,
  rtlsScreenshot3M,
  rtlsScreenshot4D,
  rtlsScreenshot4T,
  rtlsScreenshot4M,
  rtlsMainBanner,
  rtlsMainBannerProduct,
} from '@assets/images/main/index';
import {
  RtlsFunctions1D,
  RtlsFunctions1M,
  RtlsFunctions1T,
  RtlsFunctions2D,
  RtlsFunctions2M,
  RtlsFunctions2T,
  RtlsFunctions3D,
  RtlsFunctions3M,
  RtlsFunctions3T,
  RtlsFunctions4D,
  RtlsFunctions4M,
  RtlsFunctions4T,
  RtlsFunctions5D,
  RtlsFunctions5M,
  RtlsFunctions5T,
} from '@assets/images/main/rtls/main/functions';
import {
  RtlsHardware1D,
  RtlsHardware1M,
  RtlsHardware1T,
  RtlsHardware2D,
  RtlsHardware2M,
  RtlsHardware2T,
  RtlsHardware3D,
  RtlsHardware3M,
  RtlsHardware3T,
  RtlsHardware4D,
  RtlsHardware4M,
  RtlsHardware4T,
} from '@assets/images/main/rtls/main/hardware';
import { assetTag, twinTracker1, twinTrackerBracket } from '@assets/images/main/rtls/product';
import {
  screenViewRtls1,
  screenViewRtls2,
  screenViewRtls3,
  screenViewRtls4,
  screenViewRtls5,
  screenViewRtls6,
  screenViewRtls7,
  screenViewRtls8,
} from '@assets/images/main/screenView';
import { ReactComponent as SvgScope } from '@assets/images/icon/svg/scope.svg';
import { ReactComponent as SvgBuildingLine } from '@assets/images/icon/svg/building-line.svg';
import { ReactComponent as SvgTopology } from '@assets/images/icon/svg/topology.svg';
import { ReactComponent as SvgZoneLine } from '@assets/images/icon/svg/zone-line.svg';
import { ReactComponent as SvgSunLine } from '@assets/images/icon/svg/sun-line.svg';
import { ReactComponent as SvgRoute } from '@assets/images/icon/svg/route.svg';
import { ReactComponent as SvgTagsLine } from '@assets/images/icon/svg/tags-line.svg';
import { ReactComponent as Svg3DLine } from '@assets/images/icon/svg/3d-line.svg';

export default {
  banner: {
    title: 'Định vị trong nhà<br/>Đơn giản hơn. Chính xác hơn.',
    bgImg: rtlsMainBanner,
    desc: 'Từ thiết bị cố định đến di động,<br/>hãy trải nghiệm công nghệ theo dõi vị trí độ chính xác cao, không giới hạn không gian',
    productImg: rtlsMainBannerProduct,
    schemeTitle: 'Hãy chọn giải pháp theo dõi vị trí phù hợp với bạn.',
    schemeDesc: 'Cần hỗ trợ quyết định?',
    schemeDesc2: 'vui lòng liên hệ để chuyên gia hỗ trợ bạn.',
    phone: '1522-9928',

    card: [
      {
        title: 'Độc quyền trong nước',
        desc: 'Sản xuất<br/>thiết bị mạng định vị duy nhất',
      },
      {
        title: '50 tỷ +',
        desc: 'Quy mô dữ liệu vị trí thời gian thực lớn nhất<br/>châu Á',
      },
      {
        title: 'Hiệu suất hàng đầu thế giới',
        desc: 'Độ chính xác vị trí hàng đầu<br/>nhờ thuật toán AI',
      },
    ],
  },

  mainPage: {
    product: {
      title: 'Khám phá sản phẩm',
      desc: 'Xem cấu hình sản phẩm định vị sáng tạo.',
      asset: {
        title: 'Định vị Bluetooth (BLE)',
        desc: 'Gắn tag BLE lên tài sản hoặc đối tượng<br/>để định vị thời gian thực',
      },
      worker: {
        title: 'Định vị UWB chính xác cao',
        desc: 'Gắn tag UWB lên tài sản hoặc đối tượng<br/>để theo dõi vị trí và hành trình thời gian thực',
      },
    },
  },
  screenView: {
    title: 'Kết nối tài sản và không gian bằng định vị chính xác',
    data: [
      { icon: SvgScope, text: 'Theo dõi vị trí theo thời gian thực', img: screenViewRtls1 },
      { icon: SvgBuildingLine, text: 'Quản lý tài sản quy mô lớn', img: screenViewRtls2 },
      { icon: SvgTopology, text: 'Kiểm tra trạng thái mạng', img: screenViewRtls3 },
      { icon: SvgZoneLine, text: 'Quản lý khu vực', img: screenViewRtls4 },
      { icon: SvgSunLine, text: 'Phân tích không gian bằng bản đồ nhiệt', img: screenViewRtls5 },
      { icon: SvgRoute, text: 'Phân tích theo lộ trình di chuyển', img: screenViewRtls6 },
      { icon: SvgTagsLine, text: 'Quản lý thiết bị gắn thẻ', img: screenViewRtls7 },
      { icon: Svg3DLine, text: 'Hỗ trợ trình xem 3D', img: screenViewRtls8 },
    ],
  },
  screenShot: [
    {
      title: 'Triển khai toàn bộ hiện trường trên bản đồ',
      desc: 'Thông tin vị trí dựa trên BLE/UWB/AoA được hiển thị thời gian thực trên sơ đồ tòa nhà hoặc bản đồ khu vực.<br/>Dễ dàng quản lý trực quan với các tính năng xem theo tầng, bộ lọc khu vực và biểu tượng trạng thái.',
      img: {
        desktop: rtlsScreenshot1D,
        tablet: rtlsScreenshot1T,
        mobile: rtlsScreenshot1M,
      },
    },
    {
      title: 'Xem lại lịch sử di chuyển sống động như đang diễn ra ở hiện tại',
      desc: 'Lịch sử di chuyển của nhân sự hoặc tài sản có thể được ghi lại/phát lại dựa trên timeline.<br/>Bằng cách chọn một khoảng thời gian cụ thể, bạn có thể so sánh đồng thời lộ trình di chuyển của một hay nhiều đối tượng, hoặc xem xét lại các tình huống bất thường.',
      img: {
        desktop: rtlsScreenshot2D,
        tablet: rtlsScreenshot2T,
        mobile: rtlsScreenshot2M,
      },
    },
    {
      title: 'Dễ dàng nhận biết khu vực có nhiều chuyển động nhất',
      desc: 'Chúng tôi cung cấp tính năng heatmap, thể hiện trực quan lượng di chuyển theo từng khung giờ.<br/>Có thể sử dụng để phân tích các khu vực tập trung nhiều người, lộ trình di chuyển chưa tối ưu hoặc khu vực không được sử dụng, từ đó hỗ trợ cải thiện bố cục không gian và tối ưu phân bổ nhân sự.',
      img: {
        desktop: rtlsScreenshot3D,
        tablet: rtlsScreenshot3T,
        mobile: rtlsScreenshot3M,
      },
    },
    {
      title: 'Hệ thống phản hồi ngay khi có đối tượng di chuyển vào khu vực được chỉ định',
      desc: 'Trong ORBRO OS, bạn có thể trực tiếp thiết lập các Zone (vùng/khu vực) mong muốn ngay trên bản đồ.<br/>Khi nhân sự hoặc tài sản vào/ra Zone, hệ thống gửi cảnh báo ngay lập tức.<br/>Hệ thống thông báo này cũng được cung cấp qua API, cho phép tích hợp linh hoạt với các hệ thống bên ngoài.',
      img: {
        desktop: rtlsScreenshot4D,
        tablet: rtlsScreenshot4T,
        mobile: rtlsScreenshot4M,
      },
    },
  ],

  video: {
    title: 'Hệ thống định vị ORBRO',
    desc: [
      { text: 'Qua dashboard, bạn có thể nhanh chóng kiểm tra trạng thái thiết bị, xu hướng tag, phân loại theo danh mục và tình hình theo khu vực.' },
      { text: 'Xem vị trí và trạng thái đối tượng theo thiết bị.<br/>Giao diện thân thiện, dữ liệu chính xác.' },
      { text: 'Cài đặt nhanh từ khu vực làm việc đến vùng nguy hiểm.<br/>Real-Time tình hình từng Zone.' },
      { text: 'Gửi cảnh báo ngay khi vào vùng nguy hiểm hoặc sự kiện khác.' },
    ],
  },

  functions: {
    title: 'Trải nghiệm<br/>đột phá với hệ thống định vị',
    desc: 'ORBRO cung cấp cả web quản trị và app di động, mang đến trải nghiệm tối ưu. <br/>Khám phá sự tiện lợi hàng đầu trong các hệ thống định vị hiện nay.',

    line: 2,
    card: [
      {
        size: '3',
        tag: 'Phần mềm quản lý tập trung',
        title: 'Cung cấp phần mềm<br/>dựa trên bản đồ nội thất',
        label: 'Quản trị viên',
        img: {
          desktop: RtlsFunctions1D,
          tablet: RtlsFunctions1T,
          mobile: RtlsFunctions1M,
        },
      },
      {
        size: '1',
        tag: 'App di động',
        title: 'Theo dõi vị trí<br/>qua app',
        label: 'Cung cấp chung',
        img: {
          desktop: RtlsFunctions2D,
          tablet: RtlsFunctions2T,
          mobile: RtlsFunctions2M,
        },
      },
      {
        size: '2',
        tag: 'Quản lý lịch sử thiết bị',
        title: 'Tải về lịch sử vị trí<br/>theo khu vực',
        label: 'Quản trị viên',
        img: {
          desktop: RtlsFunctions3D,
          tablet: RtlsFunctions3T,
          mobile: RtlsFunctions3M,
        },
      },
      {
        size: '2',
        tag: 'Thiết lập Zone',
        title: 'Theo dõi thiết bị<br/>tại Zone',
        label: 'Quản trị viên',
        img: {
          desktop: RtlsFunctions4D,
          tablet: RtlsFunctions4T,
          mobile: RtlsFunctions4M,
        },
      },
      {
        size: '2',
        tag: 'Quản lý thiết bị',
        title: 'Quản lý<br/>thiết bị dễ dàng',
        label: 'Quản trị viên',
        img: {
          desktop: RtlsFunctions5D,
          tablet: RtlsFunctions5T,
          mobile: RtlsFunctions5M,
        },
      },
    ],
  },

  hardware: {
    title: 'Phần cứng là cốt lõi,<br/>đổi mới mọi thứ, nhẹ nhàng mà hiệu quả.',
    desc: 'Thiết bị định vị ORBRO là sản phẩm thiết kế chuyên dụng với ăng-ten định hướng và vỏ phù hợp môi trường hiện trường.<br/>Tối ưu hiệu suất và độ ổn định trong mọi điều kiện.',
    card: [
      {
        img: {
          desktop: RtlsHardware1D,
          tablet: RtlsHardware1T,
          mobile: RtlsHardware1M,
        },
        tag: 'Ăng-ten định hướng',
        title: 'Ăng-ten định hướng<br/>cho độ chính xác cao',
        desc: 'Ăng-ten trên TwinTracker giúp<br/>xác định hướng tín hiệu không dây.',
      },
      {
        img: {
          desktop: RtlsHardware2D,
          tablet: RtlsHardware2T,
          mobile: RtlsHardware2M,
        },
        tag: 'Đa dạng giá đỡ',
        title: 'Lắp âm trần,<br/>trên ray dễ dàng',
        falldown: [
          {
            title: 'Giá âm trần',
            desc: 'Phù hợp thạch cao, tex, SMC, Mytone…',
          },
          {
            title: 'Giá ray',
            desc: 'Lắp lên ray đèn tiêu chuẩn nhanh chóng.',
          },
        ],
      },
      {
        img: {
          desktop: RtlsHardware3D,
          tablet: RtlsHardware3T,
          mobile: RtlsHardware3M,
        },
        tag: 'Công nghệ tiên tiến',
        title: 'TDoA –<br/>tối thiểu thiết lập, tối đa hiệu suất',
        desc: 'TDoA giữ hiệu suất cao trong khi<br/>giảm tối đa tiêu thụ pin, mang lại độ chính xác vượt trội.',
      },
      {
        img: {
          desktop: RtlsHardware4D,
          tablet: RtlsHardware4T,
          mobile: RtlsHardware4M,
        },
        tag: 'Kết nối đa dạng',
        title: 'Hỗ trợ kết nối<br/>có dây và không dây',
      },
    ],
  },

  faqRequest: 'Mọi thắc mắc xin',
  faqRequestTail: 'liên hệ với chúng tôi.',
  FAQ: [
    {
      title: 'Tôi không có kiến thức chuyên môn về công nghệ. Liệu tôi vẫn có thể sử dụng được không?',
      description:
        'Hệ thống ORBRO được thiết kế với giao diện đơn giản nhưng mạnh mẽ, giúp người dùng không có kiến thức kỹ thuật vẫn có thể sử dụng dễ dàng. <br/>Đặc biệt, hệ thống hiển thị dữ liệu theo cách trực quan và dễ hiểu, hỗ trợ phân tích và sử dụng hiệu quả ngay cả với người mới',
    },
    {
      title: 'Độ chính xác của việc định vị trong hệ thống như thế nào?',
      description:
        'Hệ thống ORBRO RTLS có độ chính xác rất cao trong việc theo dõi vị trí.<br/>Vì việc phản ánh dữ liệu theo thời gian thực là yếu tố quan trọng, hệ thống đảm bảo kết nối dữ liệu nhanh chóng và gần như không có sai số.',
    },
    {
      title: 'Các sản phẩm này chỉ dùng để theo dõi vị trí thôi sao? Tôi muốn thêm các chức năng khác nữa.',
      description:
        'Công nghệ của ORBRO có khả năng mở rộng rất cao.<br/>Ngoài theo dõi vị trí, còn hỗ trợ nhiều tính năng đa dạng khác như phân tích lộ trình di chuyển, cảnh báo khi lệch khỏi tuyến đường định sẵn, thiết lập vùng cấm tiếp cận, cùng với nhiều khả năng ứng dụng linh hoạt tùy theo nhu cầu sử dụng.',
    },
    {
      title: 'Hệ thống theo dõi vị trí của ORBRO hoạt động như thế nào?',
      description:
        'ORBRO sử dụng các công nghệ sóng vô tuyến như BLE, UWB, AoA, trong đó các tín hiệu được phát từ thiết bị Tag sẽ được các điểm Anchor thu nhận để tính toán vị trí.<br/>Thông tin vị trí được tính toán sẽ được hiển thị theo thời gian thực trên bản đồ của hệ điều hành ORBRO OS, đồng thời cũng có thể xem trực tiếp trên ứng dụng di động.',
    },
    {
      title: 'TwinTracker BLE, UWB, AoA khác nhau như thế nào?',
      description:
        'BLE: Tiêu thụ điện năng thấp, dễ lắp đặt, độ chính xác khoảng 1–3m<br/>UWB: Độ chính xác cao (10-30 cm), phản hồi nhanh, phù hợp với môi trường phức tạp.<br/>AoA: Tính toán vị trí dựa trên góc tới của tín hiệu BLE, thuận lợi cho việc phân tích lộ trình di chuyển chính xác trong nhà.',
    },
    {
      title: 'Comfort Kit có tích hợp được với hệ thống ORBRO không?',
      description:
        'Comfort Kit là sản phẩm độc lập dựa trên nền tảng di động, có thể sử dụng mà không cần ORBRO OS hay Server.<br/>Người dùng có thể theo dõi vị trí thời gian thực qua ứng dụng điện thoại, rất tiện lợi trong những môi trường không thể cài đặt Server.',
    },
    {
      title: 'ORBRO OS được sử dụng trong những môi trường nào?',
      description:
        'ORBRO OS được triển khai trong môi trường có cài đặt ORBRO Server hoặc ORBRO Edge,<br/>cung cấp các chức năng như theo dõi vị trí, giám sát sự kiện và phân tích lịch sử.<br/>Giao diện người dùng dựa trên bản đồ giúp trực quan hóa dữ liệu, được thiết kế để các người quản trị và người vận hành dễ dàng sử dụng.',
    },
    {
      title: 'Thông tin vị trí đã tính toán có thể được sử dụng bởi hệ thống bên ngoài không?',
      description:
        'Vâng có thể, ORBRO cung cấp API cho phép tích hợp dữ liệu vị trí với các hệ thống bên ngoài.<br/>Nhờ đó, dữ liệu có thể được đồng bộ với hệ thống khách hàng, nền tảng nhà máy thông minh, hệ thống giám sát an ninh và nhiều ứng dụng khác.',
    },
    {
      title: 'Có thể sử dụng nhiều sản phẩm cùng lúc trong một công trường không?',
      description:
        'Hoàn toàn có thể.<br/>Các sản phẩm dựa trên BLE, UWB và AoA có thể được kết hợp vận hành đồng thời trên cùng một nền tảng,<br/>giúp tạo nên giải pháp tối ưu phù hợp với môi trường phức hợp.',
    },
    {
      title: 'Hệ thống có thể theo dõi vị trí cả trong nhà và ngoài trời không?',
      description:
        'Có thể.<br/>Ở trong nhà, hệ thống sử dụng các công nghệ như BLE, UWB và AoA,<br/>còn ngoài trời, có thể tích hợp với định vị GPS để vận hành dưới dạng cấu hình Hybrid (kết hợp), đáp ứng nhu cầu theo dõi vị trí trong mọi môi trường.',
    },
    {
      title: 'Có thể vận hành bao nhiêu thiết bị Tag cùng lúc?',
      description:
        'Tùy theo cấu hình hệ thống và năng lực máy chủ, hệ thống có thể mở rộng từ vài chục đến hàng nghìn thiết bị Tag.<br/>ORBRO đảm bảo hiệu suất theo dõi ổn định ngay cả trong các môi trường quy mô lớn.',
    },
    {
      title: 'Việc lắp đặt và bảo trì có phức tạp không?',
      description:
        'ORBRO hỗ trợ toàn bộ quy trình từ thiết kế lắp đặt, thi công đến vận hành thử nghiệm.<br/>Hầu hết thiết bị đều có thể kiểm tra trạng thái và cập nhật firmware từ xa.<br/>Việc bảo trì rất đơn giản, chủ yếu chỉ cần thay pin định kỳ và kiểm tra thiết bị theo lịch định kỳ là đủ.',
    },
    {
      title: 'Làm thế nào để kiểm tra theo dõi thông tin vị trí?',
      description:
        'Dữ liệu vị trí được hiển thị trực quan trên giao diện bản đồ của ORBRO OS,<br/>và có thể theo dõi đồng thời qua ứng dụng di động.<br/>Ngoài ra, nhờ API tích hợp, dữ liệu có thể được kết nối với các hệ thống bên ngoài, mang lại khả năng ứng dụng linh hoạt trong nhiều môi trường vận hành khác nhau.',
    },
  ],

  bannerData: [
    {
      icon: IconTwintrackerOn,
      iconInv: IconTwintrackerOff,
      image: '',
      iconText: 'TwinTracker UWB',
      sub: 'New',
      link: '/vi/rtls/uwb',
    },
    {
      icon: IconAoaOn,
      iconInv: IconAoaOff,
      image: '',
      iconText: 'TwinTracker AoA',
      sub: 'New',
      link: '/vi/rtls/aoa',
    },
    {
      icon: IconTwintrackerOn,
      iconInv: IconTwintrackerOff,
      image: '',
      iconText: 'TwinTracker BLE',
      sub: 'New',
      link: '/vi/rtls/ble',
    },
    {
      icon: IconComfortOn,
      iconInv: IconComfortOff,
      image: '',
      iconText: 'Comfort Kit',
      sub: 'New',
      link: '/vi/rtls/comfort',
    },
  ],

  product: {
    asset: {
      func: 'Thiết bị có pin tích hợp, không cần lắp đặt nguồn, gắn cạnh cửa để điều khiển ngay qua di động.',
      key1: accessKey1,
      key2: accessKey2,
      key3: accessKey3,
      key4: accessKey4,
      outlook: accessOutlook,
    },
  },

  purchaseDesc: {
    asset: 'Gắn tag BLE lên tài sản hoặc đối tượng để định vị.',
    worker: 'Gắn tag UWB lên tài sản hoặc đối tượng để định vị.',
  },

  purchase: {
    asset: {
      assetTracking: {
        icon: accessKey1,
        title: 'Định vị tài sản',
        serial: 'Asset-Tracking',
        price: '5.900.000',

        note: [
          { text: '10 TwinTracker (BLE)', icon: IconBox },
          { text: '30 tag tài sản', icon: IconBox },
          { text: '1 Server PC', icon: IconComputer },
          { text: 'Bảo hành 3 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Tag Asset (BLE)',
            price: '30.000',
            img: assetTag,
          },
          {
            title: 'TwinTracker (BLE)',
            price: '300.000',
            img: twinTracker1,
          },
          {
            title: 'Giá gắn TwinTracker',
            price: '100.000',
            img: twinTrackerBracket,
          },
        ],
        mark: '',
      },
    },

    worker: {
      workerTracking: {
        icon: accessKey1,
        title: 'Định vị nhân sự',
        serial: 'Worker-Tracking',
        price: '5.000.000',

        note: [
          { text: '10 TwinTracker (UWB)', icon: IconBox },
          { text: '10 tag nhân sự', icon: IconBox },
          { text: '1 Server PC', icon: IconComputer },
          { text: 'Bảo hành 3 năm', icon: IconGuarantee },
        ],

        parts: [
          {
            title: 'Tag (UWB)',
            price: '60.000',
            img: emlockThumb,
          },
          {
            title: 'TwinTracker (UWB)',
            price: '300.000',
            img: deadboltThumb,
          },
          {
            title: 'Giá gắn TwinTracker',
            price: '100.000',
            img: accessAutoThumb,
          },
        ],
        mark: '',
      },
    },
  },

  func: {
    title: 'Tìm hiểu thêm các tính năng',
    desc: 'Khám phá các tính năng định vị đa dạng.',

    data: [
      {
        img: IconBlueShield,
        title: 'Quản lý quyền hạn và nhóm người dùng',
        desc: 'Phân quyền rõ ràng giữa người quản trị và người dùng, kiểm soát truy cập chức năng theo vai trò. Hỗ trợ tạo nhóm theo phòng ban hoặc đội nhóm.',
      },
      {
        img: IconAlarm,
        title: 'Cài đặt thông báo theo điều kiện (5 cấp độ)',
        desc: 'Cho phép cấu hình cảnh báo theo 5 cấp độ dựa trên các điều kiện được thiết lập sẵn, giúp phát hiện nhanh và xử lý kịp thời các dấu hiệu bất thường.',
      },
      {
        img: Icon3dMeter,
        title: 'Giám sát khu vực (Zone)',
        desc: 'Thiết lập Zone trực tiếp trên bản đồ và theo dõi người hoặc tài sản di chuyển vào khu vực đó theo thời gian thực.',
      },
      {
        img: Icon3dCycle,
        title: 'Phát hiện di chuyển ngược chiều',
        desc: 'Hệ thống tự động phát hiện các chuyển động ngược với hướng di chuyển đã định, và phát cảnh báo khi phát hiện bất thường.',
      },
      {
        img: Icon3dLocation,
        title: 'Quản lý theo dõi dựa trên danh mục',
        desc: 'Phân loại thiết bị gắn thẻ (Tag) theo nhân sự, tài sản, phương tiện, v.v., giúp quản lý dữ liệu hiệu quả và hỗ trợ phân tích thống kê.',
      },
      {
        img: Icon3dAlert,
        title: 'Thông báo khi Tag không có tín hiệu trong thời gian dài',
        desc: 'Tự động gửi cảnh báo đến người quản trị nếu thẻ không phát tín hiệu trong một khoảng thời gian nhất định.',
      },
      {
        img: Icon3dDetect,
        title: 'Phát hiện ra/vào khu vực (In/Out Zone)',
        desc: 'Tự động nhận diện việc ra vào và rời khỏi các khu vực được chỉ định, hỗ trợ ghi nhận lịch sử ra vào và phân tích thời gian lưu trú.',
      },
      {
        img: Icon3d3d,
        title: 'Tìm kiếm thiết bị và quản lý trạng thái',
        desc: 'Dễ dàng tìm kiếm nhiều thiết bị Tag và Anchor, theo dõi trạng thái kết nối, mức pin, và quản lý tổng thể một cách trực quan.',
      },
    ],
  },
};
